import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared.module';

import { ConnectionsCatalogComponent } from '../catalogs/connections-catalog/connections-catalog.component';
import { GradesCatalogComponent } from '../catalogs/grades-catalog/grades-catalog.component';
import { PipesCatalogComponent } from '../catalogs/pipes-catalog/pipes-catalog/pipes-catalog.component';
import { FormationsCementCatalogComponent } from '../catalogs/formations-cement-catalog/formations-cement-catalog.component';
import { FormationsCatalogComponent } from '../catalogs/formations-cement-catalog/formations-catalog/formations-catalog.component';
import { CementCatalogComponent } from '../catalogs/formations-cement-catalog/cement-catalog/cement-catalog.component';
import { TemperatureDerationComponent } from '../catalogs/temperature-deration/temperature-deration.component';
import { TemperatureDerationPlotComponent } from '../catalogs/temperature-deration/temperature-deration-plot.component';
import { CdkCopyToClipboard } from "@angular/cdk/clipboard";

const components =  [
  GradesCatalogComponent,
  PipesCatalogComponent,
  ConnectionsCatalogComponent,
  FormationsCementCatalogComponent,
  FormationsCatalogComponent,
  CementCatalogComponent,
  TemperatureDerationComponent,
  TemperatureDerationPlotComponent
];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CommonModule,
    SharedModule,
    CdkCopyToClipboard
],
  exports: [
    ...components
  ]
})
export class CatalogsModule { }
